<template>
	<div class="selectreportTypes" v-if="isShow">
		<TOP title="举报" :isBack="true" from="selectHuati"></TOP>
		<!-- <img class="backBtn" src="@/assets/images/back_w.png" @click="closeFun" /> -->
		<van-button class="comfirmBtn" v-preventReClick="1000" @click="comfirmSelect">提交</van-button>
		<div class="reportTypesList">
			<van-list v-model:loading="loading" :finished="finished" :finished-text="finishTxt" @load="loadData">
				<van-radio-group v-model="type">
					<van-radio  checked-color="#F7DE7D" v-for="(item,index) in listData" :key="index" :name="item.id">
						<div class="reportTypesDetail">
							<div class="reportTypesInfoBox">
								<div class="reportTypesinfo">
									<div class="reportTypesName">{{item.name}}</div>
								</div>
							</div>
						</div>
					</van-radio>
				</van-radio-group>
			</van-list>
		</div>
		
	</div>
</template>

<script>
	import {
		defineComponent
	} from 'vue';
	import TOP from '@/components/top/top.vue';
	import common from '@/util/common';
	
	import {
		RadioGroup,
		Radio,
		List,
		Toast,
		Button
		
	} from 'vant';
	import request from '@/service/request'
	export default defineComponent({
		components: {
			TOP,
			[RadioGroup.name]: RadioGroup,
			[Radio.name]: Radio,
			[List.name]: List,
			[Button.name]: Button
		},
		mounted() {
			document.querySelector("body").setAttribute("style",
				"background: linear-gradient(0deg, #EDEDD0, #DBEFE7);");
		},
		// unmounted() {
		// 	document.querySelector("body").setAttribute("style",
		// 		"background: linear-gradient(#95C5B5, #64A4A4) no-repeat;");
		// },
		data() {
			return {
				loading: false, //是否处于加载状态，加载过程中不触发 load 事件
				listData: [],
				page: 1,
				finishTxt: "没有更多了",
				finished: true,
				type: ''
			}
		},
		props:{
			isShow:{
				type:Boolean,
				default:false
			},
			pid:{
				type:String,
				default:''
			}
		},
		created() {
			this.getData();
		},
		methods: {
			loadData() {
				this.getData();
			},
			getData() {
				request.apiAxios({
					method: 'post',
					url: request.REPORTTYPES
				}).then((res) => {
					if (res.status) {
						if (res.data.length > 0) {
							//if (this.listData.length == 0) {
								this.listData = res.data;
							// } else {
							// 	this.listData = this.listData.concat(res.data);
							// }
							// this.finished = false;
						} else {
							//this.finished = true;
						}
						// this.page++;
					}
					//this.loading = false;
				}).catch((err) => {
					console.log(err);
					//this.finished = true;
				})
			},
			comfirmSelect(){
				if(!this.type){
					Toast("请选择分类！");
					return;
				}
				if(common.isLogin()){
					request.apiAxios({
						method: 'post',
						url: request.REPORTPOST,
						data: {
							pid: this.pid,
							token:window.localStorage.getItem('token'),
							type:this.type
						}
					}).then((res) => {
						
						if (res.status) {
							console.log(res);
							Toast("举报成功！");
							this.closeFun();
						}else{
							Toast(res.message);
						}
					}).catch((err) => {
						console.log(err);
					})
				}
			},
			closeFun(){
				this.$parent.closeReportTypes();
			}
		},

	});
</script>

<style lang="less" scoped="scoped">
	.backBtn {
		position: fixed;
		width: 0.33rem;
		height: 0.31rem;
		left: 0.24rem;
		top: 0.3rem;
		margin-right: 0.4rem;
		z-index:10000;
	}
	.selectreportTypes{
		position: fixed;
		top: 0;
		bottom:0;
		right:0;
		left:0;
		z-index:1005;
		overflow-y:auto;
		background: linear-gradient(0deg, #EDEDD0, #DBEFE7);
	}
	.comfirmBtn {
		position: fixed;
		right: 0.2rem;
		top: 0.13rem;
		width: 1.22rem;
		height: 0.64rem;
		background: #F8FAF5;
		box-shadow: 0px 1px 2px 0px rgba(161, 161, 136, 0.36);
		border-radius: 0.32rem;
		font-size: 0.3rem;
		font-family: SimHei;
		font-weight: 400;
		color: #4A898B;
		text-align: center;
		line-height: 0.64rem;
		z-index: 10000;
	}

	.reportTypesList {
		padding: 0.2rem;

		.reportTypesDetail {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.reportTypesInfoBox {
			display: flex;
			flex: auto;
			color: #5D6262;
		}

		.reportTypesIcon {
			width: 1.06rem;
			height: 1.06rem;
			margin-right: 0.2rem;
			flex: none;
		}

		.reportTypesinfo {
			flex: auto;
			align-items: center;
			display: flex;
			justify-content: space-around;
			flex-direction: column;
			text-align: left;
			line-height: 0.45rem;

			&>div {
				width: 100%;
				height: 0.45rem;
				overflow: hidden;
			}

			margin-right:0.2rem;
		}

		.reportTypesNum {
			background-image: -webkit-linear-gradient(bottom, red, #F34701, #FB8A0F);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			font-size: 0.25rem;
			width: 1rem;
			text-align: right;
			margin-top: 0.7rem;
			margin-right: 0.1rem;
			flex: none;
		}
	}
</style>
<style lang="less">
	.reportTypesList {
		.van-radio {
			width: 100%;
			background: #F8FAF5;
			box-shadow: 0px 1px 2px 0px rgba(161, 161, 136, 0.36);
			border-radius: 0.14rem;
			padding: 0.16rem 0.2rem;
			position: relative;
			margin-bottom: 0.2rem;

			.van-radio__icon {
				position: absolute;
				right: 0.22rem;
				top: 0.2rem;
			}

			.van-radio__label {
				width: 100%;
			}
		}
	}
	.selectreportTypes{
		.van-button__text{
			font-size:0.26rem
		}
	}
	
</style>
